import { AutoWireViewWithRerender } from '../common/util/util';
import { createOpenUtil } from './common/util';
import View from './index';
import './view.scss';

createOpenUtil();

// 装配rerender功能
const ViewWithRerender = AutoWireViewWithRerender(View);

window['cn-ui-charts'] = ViewWithRerender;
export default ViewWithRerender;
